import { type FC, type HTMLAttributes, type ReactNode } from 'react'

import './index.scss'

export interface BodyTextProps extends HTMLAttributes<HTMLParagraphElement> {
  children: ReactNode
  className?: string
}

export const BodyText: FC<BodyTextProps> = ({ children, className = '', ...rest }) => (
  <p className={`body-text ${className}`} {...rest}>
    {children}
  </p>
)
